import React from "react";
import { Button } from "@mui/material";

export default function MasterToolbarButton({
  icon,
  children,
  onClick,
}: {
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick: () => void;
}) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={icon}
      onClick={onClick}
      sx={{ flexShrink: 0, whiteSpace: "nowrap", bgcolor: "white" }}
    >
      {children}
    </Button>
  );
}
